// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHoldDto } from './IHoldDto';
import {
    IHoldDtoFromJSON,
    IHoldDtoFromJSONTyped,
    IHoldDtoToJSON,
    IHoldDtoToJSONTyped,
} from './IHoldDto';

/**
 * 
 * @export
 * @interface IPostingDto
 */
export interface IPostingDto {
    /**
     * 
     * @type {number}
     * @memberof IPostingDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPostingDto
     */
    amount?: number;
    /**
     * 
     * @type {Set<IHoldDto>}
     * @memberof IPostingDto
     */
    holds?: Set<IHoldDto>;
    /**
     * 
     * @type {number}
     * @memberof IPostingDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPostingDto
     */
    transaction_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPostingDto
     */
    external_identifier?: string;
}

/**
 * Check if a given object implements the IPostingDto interface.
 */
export function instanceOfIPostingDto(value: object): value is IPostingDto {
    return true;
}

export function IPostingDtoFromJSON(json: any): IPostingDto {
    return IPostingDtoFromJSONTyped(json, false);
}

export function IPostingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPostingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'holds': json['holds'] == null ? undefined : (new Set((json['holds'] as Array<any>).map(IHoldDtoFromJSON))),
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'transaction_id': json['transaction_id'] == null ? undefined : json['transaction_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
    };
}

export function IPostingDtoToJSON(json: any): IPostingDto {
    return IPostingDtoToJSONTyped(json, false);
}

export function IPostingDtoToJSONTyped(value?: IPostingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'holds': value['holds'] == null ? undefined : (Array.from(value['holds'] as Set<any>).map(IHoldDtoToJSON)),
        'account_id': value['account_id'],
        'transaction_id': value['transaction_id'],
        'external_identifier': value['external_identifier'],
    };
}

